import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Database from '../../controllers/Database';
import { MoreIcon, DeleteIcon, ArrowTopIcon, ArrowBottomIcon } from '../../../Icons';
import Field from '../../models/Field';
import PopoverOnClick from '../../../PopoverOnClick';
import Menu from '../../../Menu';
import generateKey from '../../utils/generateKey';
import { DATABASE_ADD_ROW } from '../../../../types/AnalyticsTypes';
import { IntersectionObserver } from '../../../../helpers/BrowserHelpers';

var RecordRowCell =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RecordRowCell, _React$PureComponent);

  function RecordRowCell(props) {
    var _this;

    _classCallCheck(this, RecordRowCell);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecordRowCell).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "scrollCellIntoView", function () {
      var cellElement = _this.cellRef.current;

      _this.props.database.scrollInsideDatabase(cellElement);
    });

    _defineProperty(_assertThisInitialized(_this), "disconnectObserver", function () {
      return _this.observer && _this.observer.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "onIntersection", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          _ref2 = _slicedToArray(_ref, 1),
          _ref2$ = _ref2[0];

      _ref2$ = _ref2$ === void 0 ? {} : _ref2$;
      var _ref2$$isIntersecting = _ref2$.isIntersecting,
          isIntersecting = _ref2$$isIntersecting === void 0 ? false : _ref2$$isIntersecting;
      return !isIntersecting && _this.setState({
        isControlOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "connectObserver", function () {
      if (!_this.moreButtonRef.current) return;
      var database = _this.props.database;
      _this.observer = new IntersectionObserver(_this.onIntersection, {
        root: database.element,
        rootMargin: '0px',
        threshold: 0
      });

      _this.observer.observe(_this.moreButtonRef.current);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        isHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (!_this.props.database.readOnly && !_this.props.isActive) {
        _this.props.database.activate(_this.props.record.key, _this.getField().columnKey);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDoubleClick", function () {
      if (!_this.props.database.readOnly && !_this.props.isFocused && _this.props.database.run('canEdit', _this.props.column.type)) {
        _this.props.database.focus(_this.props.record.key, _this.getField().columnKey);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteRecord", function () {
      _this.props.database.deleteRecord(_this.props.record.key);
    });

    _defineProperty(_assertThisInitialized(_this), "onInsertAbove", function () {
      var newRecordKey = generateKey();

      _this.props.database.insertRecordBefore(_this.props.record.key, {
        key: newRecordKey
      }).focus(newRecordKey, _this.props.column.key).command('track', DATABASE_ADD_ROW, {
        source: 'Click insert above'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInsertBelow", function () {
      var newRecordKey = generateKey();

      _this.props.database.insertRecordAfter(_this.props.record.key, {
        key: newRecordKey
      }).focus(newRecordKey, _this.props.column.key).command('track', DATABASE_ADD_ROW, {
        source: 'Click insert below'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCellControls", function (_ref3) {
      var closePopover = _ref3.closePopover;
      return React.createElement(Menu, {
        style: {
          width: 220
        },
        onRowClick: closePopover,
        items: _this.menuItems
      });
    });

    _this.state = {
      isHovered: false,
      isControlOpen: false
    };
    _this.observer = null;
    _this.cellRef = React.createRef();
    _this.moreButtonRef = React.createRef();
    _this.menuItems = [{
      key: 'insert-above',
      title: 'Insert above',
      icon: ArrowTopIcon,
      action: _this.onInsertAbove
    }, {
      key: 'insert-below',
      title: 'Insert below',
      icon: ArrowBottomIcon,
      action: _this.onInsertBelow
    }, {
      key: 'delete',
      title: 'Delete',
      icon: DeleteIcon,
      action: _this.onDeleteRecord
    }];
    return _this;
  }

  _createClass(RecordRowCell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isFocused || this.props.isActive) {
        this.scrollCellIntoView();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isControlOpen && !this.state.isControlOpen) {
        this.disconnectObserver();
      }

      if (!prevState.isControlOpen && this.state.isControlOpen) {
        this.connectObserver();
      }

      if (!prevProps.isFocused && this.props.isFocused || !prevProps.isActive && this.props.isActive) {
        this.scrollCellIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disconnectObserver();
    }
  }, {
    key: "getField",
    value: function getField() {
      if (this.props.field) {
        return this.props.field;
      }

      if (this.defaultField) {
        return this.defaultField;
      }

      this.defaultField = Field.create({
        columnKey: this.props.column.key
      });
      return this.defaultField;
    }
  }, {
    key: "renderCell",
    value: function renderCell(_ref4) {
      var isFocused = _ref4.isFocused,
          isSelected = _ref4.isSelected,
          isActive = _ref4.isActive;
      var _this$props = this.props,
          database = _this$props.database,
          column = _this$props.column,
          record = _this$props.record;
      return database.run('renderField', {
        column: column,
        record: record,
        field: this.getField(),
        isFocused: isFocused,
        isActive: isActive,
        isSelected: isSelected,
        attributes: {
          onMouseDown: this.onMouseDown
        }
      });
    }
  }, {
    key: "renderCellIndex",
    value: function renderCellIndex() {
      var _this2 = this;

      var _this$props2 = this.props,
          rowIndex = _this$props2.rowIndex,
          database = _this$props2.database,
          isActive = _this$props2.isActive;
      var _this$state = this.state,
          isHovered = _this$state.isHovered,
          isControlOpen = _this$state.isControlOpen;
      var displayMoreOptions = (isHovered || isControlOpen || isActive) && !database.readOnly;
      return React.createElement("div", {
        style: {
          textAlign: 'right',
          width: 24
        },
        className: classNames('flexbox-no-shrink font-size-small font-weight-medium shade-30 padding-vertical-small'),
        ref: this.moreButtonRef
      }, displayMoreOptions ? React.createElement(PopoverOnClick, {
        position: "left",
        content: this.renderCellControls,
        onIsOpenChange: function onIsOpenChange(_ref5) {
          var isOpen = _ref5.isOpen;

          _this2.setState({
            isControlOpen: isOpen
          });

          if (isOpen) {
            _this2.props.database.selectRecord(_this2.props.record.key);
          }
        }
      }, React.createElement(MoreIcon, {
        className: "pointer shade-20-on-hover shade-10-on-active",
        size: 16,
        style: {
          marginRight: -5 // Align with single digit number row

        },
        "data-qa": "database-row-options"
      })) : React.createElement("div", null, rowIndex + 1));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          database = _this$props3.database,
          column = _this$props3.column,
          columnIndex = _this$props3.columnIndex,
          rowIndex = _this$props3.rowIndex,
          isFocused = _this$props3.isFocused,
          isSelected = _this$props3.isSelected,
          isActive = _this$props3.isActive;
      var isFirst = columnIndex === 0;
      var canEdit = this.props.database.run('canEdit', this.props.column.type);
      return React.createElement("td", {
        key: column.columnKey,
        ref: this.cellRef,
        "data-qa": "database-records-cell",
        "data-database-position": "".concat(rowIndex, ":").concat(columnIndex),
        className: classNames('slite-editor-database-cell', {
          'is-focused': isFocused,
          'background-primary-shade-dark': isSelected,
          'is-active': isActive,
          'is-editable': canEdit
        }),
        style: {
          width: database.run('getWidth', column.type)
        }
      }, React.createElement("div", {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseDown: this.onMouseDown,
        onDoubleClick: this.onDoubleClick,
        className: "flexbox height-full"
      }, isFirst && this.renderCellIndex(), this.renderCell({
        isFocused: isFocused,
        isSelected: isSelected,
        isActive: isActive
      })));
    }
  }]);

  return RecordRowCell;
}(React.PureComponent);

_defineProperty(RecordRowCell, "propTypes", {
  database: PropTypes.instanceOf(Database),
  columns: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
  field: PropTypes.object,
  column: PropTypes.object.isRequired,
  columnIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired,
  isFocused: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired
});

export { RecordRowCell as default };